<template>
    <div class="container remove-padding-margin">
        <div class="fixed-top fixed-judul">
            <div class="row justify-content-center align-items-center set-row">
                <div class="col-md-1 col-sm-1 col-1 remove-padding" @click="back" >
                    <img src="../../assets/gambar/back-blue.svg" alt="">
                </div>
                <div class="col-md-10 col-sm-10 col-10 text-center remove-padding">Ubah Paket E-Payment</div>
                <div class="col-md-1 col-sm-1 col-1 remove-padding"></div>
            </div>
        </div>
        <main class="add-padding-default">
            <div class="flex-100">
                <div class="flex-1">
                    <form class="set-margin" action="">
                        <div class="">
                            <label for="namapaket" class="require">Nama Paket E-Payment</label>
                            <input type="text" id="namapaket" class="form-control inputs" placeholder="Paket Epayment 20K" v-model="nama_editpayment" v-on:keyup="inputnama">
	                        <ErrorMessage class="error" label="Nama E-Payment" :validation="$v.nama_editpayment"></ErrorMessage>
                        </div>
                        <div>
                            <label for="Nominal" class="require mar-top-12">Nominal E-Payment</label>
	                        <!--<input type="text" id="Nominal" class="form-control inputs" placeholder="20.000" v-model="nominal_emoney" v-on:keyup="inputnumber">-->
	                        <InputRupiah
		                        :outerDivClass="'input-group remove-padding'"
		                        :innerDivClass="'input-group-prepend'"
		                        v-model="nominal_emoney"
		                        :showRp="true"
		                        :defaultValue="nominal_emoney.formatted"
		                        :placeholder="14000"
                            :comma="false"
                          />
	                        <ErrorMessage class="error" label="Nominal E-Payment" :validation="$v.nominal_emoney.raw"></ErrorMessage>
                        </div>
                        <div class="form-group">
                            <label class="remove-margin mar-top-12 require color-label" for="hargajual">Harga Jual</label>
                            <div class="input-group remove-padding">
                                <div class="input-group-prepend">
                                    <div class="input-group-text">Rp</div>
                                </div>
                                <input type="tel" class="form-control inputs" id="hargajual" placeholder="14.000"
                                       disabled v-model="nominal_emoney.formatted">
                            </div>
                            <div class="font-14 color-6F7288 text-small">Harga jual disamakan dengan nominal E-payment</div>
                            <div class="custom-control custom-switch mar-top-20" style="padding: 0px 12px"
                                 id="tooglemasaaktif" @click="masaaktiftoogle">
                                <input type="checkbox" class="custom-control-input" id="customSwitch3">
                                <label class="custom-control-label color-33333 font-weight-bold" for="customSwitch3"
                                id="label-customSwitch3">
	                                Aktifkan Masa Aktif
                                </label>
                            </div>
                            <div id="masaaktif">
                                <label class="remove-margin mar-top-12" for="durasi" >Masa Aktif Paket</label>
                                <div class="input-group remove-padding">
                                    <input type="tel" class="form-control inputs" id="durasi" value="0" placeholder="30" v-model="durasi_emoney" v-on:keyup="inputnumber2">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text">Hari</div>
                                    </div>
                                </div>
	                            <ErrorMessage class="error" label="Masa Aktif Paket" :validation="$v.durasi_emoney"></ErrorMessage>
                            </div>
                        </div>
                        <div class="custom-control custom-switch mar-top-20" style="padding: 0px 12px"
                             id="toogle" @click="bonus">
                            <input type="checkbox" class="custom-control-input" id="customSwitch2">
                            <label class="custom-control-label color-33333 font-weight-bold" for="customSwitch2">Aktifkan
                                Bonus</label>
                        </div>
                        <div id="inputbonus">
                            <label for="bonus">Bonus E-Payment</label>
							<!--<input type="tel" class="form-control" id="bonus" placeholder="10.000" v-model="bonus_emoney1" v-on:keyup="inputnumber1">-->
	                        <InputRupiah
		                        :outerDivClass="'input-group remove-padding'"
		                        :innerDivClass="'input-group-prepend'"
		                        v-model="bonus_emoney1"
		                        :showRp="false"
		                        :defaultValue="bonus_emoney1.formatted"
		                        :placeholder="14000"/>
	                        <ErrorMessage class="error" label="Bonus E-payment" :validation="$v.bonus_emoney1.raw"></ErrorMessage>
                        </div>
                    </form>
                </div>
                <div class="button-lanjut">
                    <button type="button" class="btn btn-login btn-long" id="BtnEditpayment" @click="ubahepayment">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                              v-if="isClicked1 === true"></span><span id="textBtnEditpayment">Simpan</span></button>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
	import {minValue, minLength, required} from "vuelidate/lib/validators";
	import InputRupiah from "@/component-items/InputRupiah";
	import ErrorMessage from "@/component-items/ErrorMessage";

    export default {
        name: "EpaymentEdit",
        props:['setidoutletsetdeposit','dataidepayment'],
	    components: { InputRupiah, ErrorMessage },
        data(){
            return{
                epayment:[],
                idoutlet:'',
                idpayment:'',
                isClicked:false,
                isClicked1:false,
                nama_editpayment:'',
                nominal_emoney: {
                	raw: 0,
	                formatted: "",
                },
                nominal_emoney1:0,
                durasi_emoney:0,
                saldo_emoney1:0,
                saldo_emoney:'',
                bonus_emoney:0,
                bonus_emoney1: {
                	raw: 0,
	                formatted: "",
                },
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                }
            }
        },
	    validations: {
		    nama_editpayment: {
		    	required,
			    minLength: minLength(2),
		    },
		    nominal_emoney: {
		    	raw: {
		    		required,
				    minValue: minValue(1)
			    }
		    },
		    durasi_emoney: {
		    	required,
			    minValue: minValue(1)
		    },
		    bonus_emoney1: {
		    	raw: {
		    		required,
				    minValue: minValue(1)
			    }
		    }
	    },
        mounted() {
            this.idoutlet = this.$route.params.idoutlet;
            this.idpayment = this.$route.params.idpayment;
            this.getDetailPayment();
            $('#masaaktif').hide()
            $('#inputbonus').hide()

            this.backButtonPressed(this.back)
        },
        methods:{
            back(){
                this.$emit('backtolist')
            },

            masaaktiftoogle(e){
                e.preventDefault()
                if (!$('#customSwitch3').is(":checked")) {
                    $('#masaaktif').slideDown(400);
                    $('#customSwitch3').prop('checked', true)
                } else {
                    $('#masaaktif').slideUp(400);
                    $('#customSwitch3').prop('checked', false)
                }
            },

            bonus(e){
                e.preventDefault()
                if (!$('#customSwitch2').is(":checked")) {
                    $('#inputbonus').slideDown(400);
                    $('#customSwitch2').prop('checked', true)
                } else {
                    $('#inputbonus').slideUp(400);
                    $('#customSwitch2').prop('checked', false)
                }
            },
            inputnama(event){
                this.cekValidasi()
                var handleevent = event.target.value;
                var handle = handleevent.replace(/[^0-9A-Za-z.,' -]+/,'');
                this.nama_editpayment = handle
            },
            inputnumber(event){
                var handleevent = event.target.value;
                var handle = handleevent.replace(/[^0-9]+/,'');
                this.nominal_emoney = handle;
                this.formatrupiahcreateepaymentnominal(event)
                this.cekValidasi()
            },

            formatrupiahcreateepaymentnominal(event) {
                var rupiah = event.target.value;
                var formattedrupiahcreate = this.newrupiahcreateepaymentnominal(rupiah);
                this.nominal_emoney = formattedrupiahcreate
            },

            newrupiahcreateepaymentnominal(angka, prefix) {
                /* Fungsi formatRupiah */
                var number_string = angka.replace(/[^.\d]/g, "").toString(),
                    split = number_string.split("."),
                    sisa = split[0].length % 3,
                    rupiah = split[0].substr(0, sisa),
                    ribuan = split[0].substr(sisa).match(/\d{3}/gi);
                // tambahkan titik jika yang di input sudah menjadi angka ribuan
                if (ribuan) {
                    var separator = sisa ? "." : "";
                    rupiah += separator + ribuan.join(".");
                }

                rupiah = split[1] != undefined ? rupiah + "," + split[1] : rupiah;
                return prefix == undefined ? rupiah : rupiah ? "Rp." + rupiah : "";
            },

            inputnumber2(event){
                this.cekValidasi()
                var durasievent = event.target.value;
                var handledurasi = durasievent.replace(/[^0-9]+/,'');
                this.durasi_emoney = handledurasi
                this.formatrupiahcreatedepositmasa(event)
            },

            formatrupiahcreatedepositmasa(event) {
                var rupiah = event.target.value;
                var formattedrupiahcreate = this.newrupiahcreatedepositmasa(rupiah);
                this.durasi_emoney = formattedrupiahcreate
            },

            newrupiahcreatedepositmasa(angka, prefix) {
                /* Fungsi formatRupiah */
                var number_string = angka.replace(/[^,\d]/g, "").toString(),
                    split = number_string.split(","),
                    sisa = split[0].length % 3,
                    rupiah = split[0].substr(0, sisa),
                    ribuan = split[0].substr(sisa).match(/\d{3}/gi);
                // tambahkan titik jika yang di input sudah menjadi angka ribuan
                if (ribuan) {
                    var separator = sisa ? "." : "";
                    rupiah += separator + ribuan.join(".");
                }

                rupiah = split[1] != undefined ? rupiah + "," + split[1] : rupiah;
                return prefix == undefined ? rupiah : rupiah ? "Rp." + rupiah : "";
            },

            inputnumber1(event){
                var bonusevent = event.target.value;
                var handlebonus = bonusevent.replace(/[^0-9]+/,'');
                this.bonus_emoney1 = handlebonus;
                this.formatrupiahcreateepaymentbonus(event)
            },

            formatrupiahcreateepaymentbonus(event) {
                var rupiah = event.target.value;
                var formattedrupiahcreate = this.newrupiahcreateepaymentbonus(rupiah);
                this.bonus_emoney1 = formattedrupiahcreate
            },

            newrupiahcreateepaymentbonus(angka, prefix) {
                /* Fungsi formatRupiah */
                var number_string = angka.replace(/[^,\d]/g, "").toString(),
                    split = number_string.split(","),
                    sisa = split[0].length % 3,
                    rupiah = split[0].substr(0, sisa),
                    ribuan = split[0].substr(sisa).match(/\d{3}/gi);
                // tambahkan titik jika yang di input sudah menjadi angka ribuan
                if (ribuan) {
                    var separator = sisa ? "." : "";
                    rupiah += separator + ribuan.join(".");
                }

                rupiah = split[1] != undefined ? rupiah + "," + split[1] : rupiah;
                return prefix == undefined ? rupiah : rupiah ? "Rp." + rupiah : "";
            },
            max30(event){
                this.cekValidasi()
                $('#durasi').keyup(function(){
                    if ($(this).val() > 30){
                        $(this).val('0');
                    }
                });
                this.inputnumber2(event)
            },
            cekValidasi(){
            	return
                var Namapaket = this.nama_editpayment;
                var nominalpaket = this.nominal_emoney;
                var Durasiaktif = this.durasi_emoney;
                var stringnominalpaket = nominalpaket.toString();
                var lenPass = Namapaket.length;
                var stringMasaAKtif = Durasiaktif.toString()
                if (lenPass >= 2 && (stringnominalpaket.length >= 3 && stringnominalpaket.length <=10)) {
                    $('#BtnEditpayment').prop('disabled', false);
                } else {
                    $('#BtnEditpayment').prop('disabled', true);
                }
            },
            hitungbonus(){
                // this.cekValidasi()
                var bonus;
                var nominal = this.nominal_emoney1;
                if (this.bonus_emoney1.formatted === null || this.bonus_emoney1.formatted === ""){
                    bonus = 0;
                }else{
                    bonus = this.bonus_emoney1.formatted;
                }
                var getbonus;
                getbonus = this.saldo_emoney1  - nominal;
	            this.bonus_emoney1.raw = getbonus
                this.bonus_emoney1.formatted = this.newrupiahcreateepaymentbonus(getbonus.toString());

                if(getbonus >0){
                    var checkBoxes = $("input[id=customSwitch2]")
                    checkBoxes.prop("checked", !checkBoxes.prop("checked"))
                    $('#inputbonus').slideDown(400);
                    $('#customSwitch2').prop('checked', true)
                } else {
                    var checkBoxes = $("input[id=customSwitch2]")
                    checkBoxes.prop("checked", false);
                }
            },
            async getDetailPayment(){
                $('#loadingPage').addClass('overlayLoading');
                $('#loadingPage').show();
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/detail_epayment?idoutlet=' + this.setidoutletsetdeposit + '&idemoney=' + this.dataidepayment.idpayment, this.requestHeaders)
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            $('#loadingPage').removeClass('overlayLoading');
                            $('#loadingPage').hide();
                            var emoneyget = response.data.data;
                            var nominalepayment = emoneyget.harga_emoney;
                            var toRPepayment = this.newrupiahcreateepaymentnominal(nominalepayment.toString());
                            var durasiepayment = this.convertMiliseconds(emoneyget.emoney.masa_aktif);
                            var toRPdurasiepayment = this.newrupiahcreateepaymentnominal(durasiepayment.toString());
                            var sldoepayment = emoneyget.emoney.saldo;
                            var toRPsaldoepayment = this.newrupiahcreateepaymentnominal(sldoepayment.toString());
                            this.convertMiliseconds();
                            this.nama_editpayment= emoneyget.emoney.nama;
                            this.nominal_emoney1 = emoneyget.harga_emoney;
	                        this.nominal_emoney.raw= nominalepayment;
                            this.nominal_emoney.formatted= toRPepayment;
                            // this.idpayment= emoneyget.emoney.iddata_emoney,
                            this.saldo_emoney= toRPsaldoepayment;
                            this.saldo_emoney1= emoneyget.emoney.saldo;
                            this.hitungbonus();
                            this.durasi_emoney= toRPdurasiepayment;
                            var masaaktif = this.durasi_emoney;
                            if(masaaktif >0 && parseInt(masaaktif.replace(".", "")) < 10000){
                                var checkBoxesmasaaktif = $("input[id=customSwitch3]");
                                checkBoxesmasaaktif.prop("checked", !checkBoxesmasaaktif.prop("checked"))
                                $('#masaaktif').slideDown(400);
                                $('#customSwitch3').prop('checked', true);
                            } else {
	                            this.durasi_emoney = "";
                                var checkBoxes1 = $("input[id=customSwitch3]");
                                checkBoxes1.prop("checked", false);
                            }
                            this.cekValidasi();

                        }
                        $('#loadingPage').removeClass('overlayLoading');
                        $('#loadingPage').hide();
                    }
                    else{
                        $('#loadingPage').removeClass('overlayLoading');
                        $('#loadingPage').hide();
                        this.$toast.error(response.data.msg)
                    }
                }catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').removeClass('overlayLoading');
	                $('#loadingPage').hide();
                }
            },
	        errorValidation() {
		        if ($("#customSwitch3").is(":checked") && $("#customSwitch2").is(":checked")) {
			        if (
				        this.$v.nama_editpayment.$invalid ||
				        this.$v.nominal_emoney.raw.$invalid ||
				        this.$v.durasi_emoney.$invalid ||
				        this.$v.bonus_emoney1.raw.$invalid
			        ) {
				        this.$v.nama_editpayment.$touch()
				        this.$v.nominal_emoney.raw.$touch()
				        this.$v.durasi_emoney.$touch()
				        this.$v.bonus_emoney1.raw.$touch()
				        this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
				        return true
			        }
		        } else if ($("#customSwitch3").is(":checked")) {
			        if (
				        this.$v.nama_editpayment.$invalid ||
				        this.$v.nominal_emoney.raw.$invalid ||
				        this.$v.durasi_emoney.$invalid
			        ) {
				        this.$v.nama_editpayment.$touch()
				        this.$v.nominal_emoney.raw.$touch()
				        this.$v.durasi_emoney.$touch()
				        this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
				        return true
			        }
		        } else if ($("#customSwitch2").is(":checked")) {
			        if (
				        this.$v.nama_editpayment.$invalid ||
				        this.$v.nominal_emoney.raw.$invalid ||
				        this.$v.bonus_emoney1.raw.$invalid
			        ) {
				        this.$v.nama_editpayment.$touch()
				        this.$v.nominal_emoney.raw.$touch()
				        this.$v.bonus_emoney1.raw.$touch()
				        this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
				        return true
			        }
		        } else {
			        if (
				        this.$v.nama_editpayment.$invalid ||
				        this.$v.nominal_emoney.raw.$invalid
			        ) {
				        this.$v.nama_editpayment.$touch()
				        this.$v.nominal_emoney.raw.$touch()
				        this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
				        return true
			        }
		        }
		        return false
	        },
            async ubahepayment(){
            	if (this.errorValidation()) {
            		return
	            }
                this.isClicked1 = true
                $('#textBtnEditpayment').hide()
                $('#BtnEditpayment').prop('disabled', true);
                try {
                    const emoney = new FormData()
                    emoney.append('idoutlet', this.setidoutletsetdeposit)
                    emoney.append('nama_paket', this.nama_editpayment)
                    emoney.append('nominal', this.nominal_emoney.formatted)
	                if (!$('#customSwitch3').is(":checked")) {
		                emoney.append('masa_aktif', "10.000")
	                } else {
		                emoney.append('masa_aktif', this.durasi_emoney)
	                }

                    if ($('#customSwitch2').is(":checked")) {
                        emoney.append('bonus_emoney', this.bonus_emoney1.formatted)
                    }


                    const response = await this.$axios.post(this.$baseurl + '/masterData/epayment/update_paket_epayment?idemoney=' + this.dataidepayment.idpayment, emoney, this.requestHeaders)
                    if(response.data.status===true){
                        this.isClicked1 = true
                        $('#textBtnEditpayment').hide()
                        $('#BtnEditpayment').prop('disabled', true);
                        this.back()
	                    this.$toast.success(response.data.msg)
                    }else {
                    	this.$toast.error(response.data.msg)
	                    this.isClicked1 = false
	                    $('#textBtnEditpayment').show()
	                    $('#BtnEditpayment').prop('disabled', false);
                    }
                }catch (e) {
                	this.$catch_error_response(e)
	                this.isClicked1 = false
	                $('#textBtnEditpayment').show()
	                $('#BtnEditpayment').prop('disabled', false);
                }
            },
            convertMiliseconds(miliseconds) {
                var days, hours, minutes, seconds, total_hours, total_minutes, total_seconds;

                total_seconds = parseInt(Math.floor(miliseconds / 1000));
                total_minutes = parseInt(Math.floor(total_seconds / 60));
                total_hours = parseInt(Math.floor(total_minutes / 60));
                days = parseInt(Math.floor(total_hours / 24));

                seconds = parseInt(total_seconds % 60);
                minutes = parseInt(total_minutes % 60);
                hours = parseInt(total_hours % 24);

                return days;
            },
        }
    }
</script>

<style scoped>
    .text-small{
        line-height: 18px;
        letter-spacing: -0.02em;
        color: #6F7287;
    }
    .color-6F7288{
        color: #6F7287;
    }
</style>